import { jsx as e, jsxs as t, Fragment as a } from "react/jsx-runtime";

import r from "@ui-components-3/ui/lib/components/Drawer";

import { useCreateAvailabilityFlow as l, CREATE_AVAILABILITY_STEPS as n } from "../../../hooks/useCreateAvailability.js";

import { useMemo as o, useId as i, useCallback as s } from "react";

import { format as m, parse as d } from "date-fns";

import { uniq as c } from "lodash";

import { useForm as p, FormProvider as u, useFormContext as h } from "react-hook-form";

import { AVAILABILITY_FREQUENCIES_MAP as f, CreateAvailabilityFormSchema as y, hasOverlappingSchedules as b } from "../../../schemas.js";

import g from "./TimeSlotsField.js";

import x from "./WeekDaysField.js";

import S from "@ui-components-3/ui/lib/components/Loading";

import k from "@ui-components-3/ui/lib/utils/classNames";

import v from "@ui-components-3/icons/lib/regular/TriangleExclamation";

import { yupResolver as N } from "@hookform/resolvers/yup";

import { useProviderSchedule as w } from "../../../hooks/useProviderSchedule.js";

import { SCHEDULE_TIME_FORMAT as D, SCHEDULE_DATE_FORMAT as C } from "../../../utils.js";

const j = () => {
    const {setCurrentStep: p, submitAvailability: u, editableSchedule: y, hasCreateError: N, hideCreateError: D} = l(), {variantClassNames: j, isSubmittingSchedule: M, schedules: T, contactSupportLink: A} = w(), {watch: q, handleSubmit: E, formState: {isValid: P}, setError: R} = h(), [F, L, V] = q([ "frequency", "startDate", "endDate" ]), B = F === f.weekly, O = i(), _ = o((() => c([ L, V ]).map((e => e ? m(d(e, C, new Date), "MM/dd") : "")).filter(Boolean).join(" - ") || ""), [ V, L ]), I = s((() => {
        p(n.dateRangeAndRepeat), D();
    }), [ D, p ]), U = o((() => B ? "Availability will occur on:" : L ? m(d(L, C, new Date), "eeee - MM/dd") : ""), [ B, L ]), W = s((e => {
        D();
        const t = y?.id ? T?.filter((e => e.id !== y.id)) : T;
        b(t || [], e) ? R("timeSegments", {
            type: "hasOverlaps",
            message: "These times overlap current open availability. Please try again."
        }) : u(e);
    }), [ y, D, T, R, u ]);
    return t(a, {
        children: [ t(r.Content, {
            className: "flex-1 !flex-nowrap",
            children: [ t("form", {
                className: "flex flex-1 flex-col gap-6 py-4",
                id: O,
                onSubmit: E(W),
                children: [ t("div", {
                    className: "flex flex-col gap-2",
                    children: [ t("p", {
                        className: "typography-body-xl py-3 font-semibold text-neutral-400",
                        children: [ "Step 1: ", _ ]
                    }), e("hr", {}), e("p", {
                        className: k("typography-body-xl py-3 font-semibold", j.textMain),
                        children: "Step 2: Choose days and add time"
                    }) ]
                }), t("div", {
                    className: "flex flex-col gap-4 rounded-2xl border border-neutral-300 bg-neutral-100 p-6",
                    children: [ e("p", {
                        className: k("typography-body-l font-semibold", j.textMain),
                        children: U
                    }), !!B && e(x, {
                        name: "byweekday"
                    }), e(g, {
                        name: "timeSegments"
                    }) ]
                }) ]
            }), (!!M || !!N) && e("div", {
                className: "typography-body py-4 text-neutral-600",
                children: t("p", N ? {
                    className: "flex items-start gap-3 text-fuchsia-800 ",
                    children: [ e(v, {
                        "aria-hidden": "true",
                        className: "mt-1.5 h-4 w-4 shrink-0"
                    }), t("span", {
                        children: [ "Unable to save your schedule. Please try again.", " ", !!A && t(a, {
                            children: [ e("a", {
                                href: A,
                                target: "_blank",
                                rel: "noreferrer",
                                className: "underline",
                                children: "Contact support"
                            }), " ", "for further assistance." ]
                        }) ]
                    }) ]
                } : {
                    children: [ "Creating your schedule. This may take a few seconds. Please do not refresh the page.", " ", !!A && t(a, {
                        children: [ "If it doesn't load,", " ", e("a", {
                            href: A,
                            target: "_blank",
                            rel: "noreferrer",
                            className: j.textLink,
                            children: "contact support"
                        }), " ", "for assistance." ]
                    }) ]
                })
            }) ]
        }), t(r.Footer, {
            children: [ e("button", {
                type: "button",
                className: k("btn", j.buttonOutlined),
                onClick: I,
                disabled: !!M,
                children: "Back"
            }), e("button", {
                type: "submit",
                form: O,
                className: k("btn", j.buttonMain),
                disabled: !P || !!M,
                children: M ? t(a, {
                    children: [ e(S, {
                        shown: !0,
                        className: "!p-0"
                    }), " Saving Schedule" ]
                }) : "Save"
            }) ]
        }) ]
    });
}, M = () => {
    const {dateRangeAndRepeatValues: t, editableSchedule: a} = l(), {byweekday: r, timeSegments: n} = a || {}, i = o((() => ({
        interval: t?.interval || null,
        startDate: t?.startDate || null,
        endDate: t?.endDate || null,
        frequency: t?.frequency || null,
        byweekday: t?.frequency === f.weekly ? r || [] : null,
        timeSegments: (n || []).map((([e, t]) => ({
            startTime: m(new Date(e), D),
            endTime: m(new Date(t), D)
        })))
    })), [ r, t, n ]), s = p({
        resolver: N(y),
        mode: "all",
        defaultValues: i
    });
    return e(u, {
        ...s,
        children: e(j, {})
    });
};

export { M as default };
//# sourceMappingURL=index.js.map
